@if ((isManualLoading | async) || (isHttpRequestLoading | async)) {
  <div class="full-screen-overlay">
    <div class="loader">
      <div
        class="d-inline-block ap-bg-neutral-02 ap-p-spacing-6 text-center rounded">
        <ap-loading
          loadingType="circular"
          [indeterminate]="true"
          [compact]="false" />
        <div
          class="ap-text-color-background-default-inverse ap-mt-spacing-4 ap-font-15 ap-font-weight-1">
          {{ 'loader.loadingMessage' | translate }}
        </div>
      </div>
    </div>
  </div>
}
